import React from 'react'

import { useLocale } from '@/hooks/routes'
import { useNormalizePublicSrc } from '@/hooks/public'
import { IS_DEV } from '@/helpers/env'
interface JsonLdProps {
  name: string
  origin: string
  address?: string
  sameAs?: string[]
  contactPoint?: any
  search?: any
  other?: any
}
export default function PublisherStructured({
  name,
  origin,
  address,
  sameAs,
  search,
  contactPoint,
  other,
}: JsonLdProps) {
  const locale = useLocale()
  const siteOrigin = locale === 'en' ? origin : `${origin}/${locale}`
  const normalizePublicSrc = useNormalizePublicSrc()
  const logoSrc = IS_DEV
    ? `${origin}/images/logo.png`
    : normalizePublicSrc('/images/logo.png')
  const publisher = JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'Organization',
    'url': siteOrigin,
    'logo': logoSrc,
    'name': name,
    address,
    'contactPoint': contactPoint,
    sameAs,
    ...search,
    ...other,
  })
  return (
    // eslint-disable-next-line react-dom/no-dangerously-set-innerhtml
    <script
      id='Organization'
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: publisher }}
    />
  )
}
